import Flag from './Flag';

export default function Lang({ suffix = "" }) {
  const humanLangs = ["en"];
  const machineLangs = [
    "pt_BR", "es", "fr", "de", "it", "hu", "tr", "ru", "he",
    "th", "vi", "ko", "zh_CN", "zh_TW", "ja"
  ];
  const prefix = suffix==""?"":"../";
  const getFlagPath = (lang) => `/assets/flags/${lang}.svg`;
  const getLink = (lang) => `${prefix}${lang == 'pt_BR'?'pt':lang }${suffix}`;

  return (
    <div className="main-container">
      <br />
      <table id="lang-table">
        <tbody>
          <tr>
            <td style={{ minWidth: "64px" }}>
              <img
                src="/assets/human-icon.svg"
                title="Translated by human"
                height="32px"
                alt="Human translation"
              />
            </td>
            {humanLangs.map((lang) => (
              <td key={lang}>
                <a href={getLink(lang)}>
                  <img width="32px" src={getFlagPath(lang)} alt={`${lang} flag`} />
                </a>
              </td>
            ))}
          </tr>
          <tr>
            <td>
              <img
                width="32px"
                height="32px"
                src="/assets/computer-icon.svg"
                title="Translated by machine"
                alt="Machine translation"
              />
            </td>
            {machineLangs.map((lang) => (
              <td key={lang}>
                <a href={getLink(lang)}>
                  <img
                    width="32px"
                    src={getFlagPath(lang)}
                    className="lang-icon"
                    alt={`${lang} flag`}
                  />
                </a>
              </td>
            ))}
          </tr>
        </tbody>
      </table>
    </div>
  );
}
